import axios from 'axios';
import {
	req,
	reqF,
} from './axiosFun';


// 获取会员卡信息
export const GetCustomerVipPageList = (params) => {
	return reqF("post", "/api/sysConfig/Vip/GetCustomerVipPageList", params)
};
// 添加会员卡
export const AddCustomerVip = (params) => {
	return reqF("post", "/api/sysConfig/Vip/AddCustomerVip", params)
};
// 获取会员消费记录分页列表
export const GetVipSpendingHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Vip/GetVipSpendingHistoryPageList", params)
};


// 获取会员卡充值分页列表
export const GetVipRechargeHistoryPageList = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/GetVipRechargeHistoryPageList", params)
};
// 保存会员充值
export const SaveVipRecharge = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/SaveVipRecharge", params)
};
// 删除会员充值
export const DeleteVipRecharge = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/DeleteVipRecharge", params)
};
// 获取会员充值记录详情
export const GetVipRechargeHistoryDetail = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/GetVipRechargeHistoryDetail", params)
};
// 确认充值
export const ConfirmVipRecharge = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/ConfirmVipRecharge", params)
};
// 充值记录补款
export const PayVipRechargeMoney = (params) => {
	return reqF("post", "/api/sysConfig/Recharge/PayVipRechargeMoney", params)
};